module.exports = __webpack_public_path__ + "01_glasses_brown.e29aca69.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer4/01_glasses_brown.png
// module id = m7ds
// module chunks = 0